import AddConnectionModal from "../connections/AddConnectionModal";
import { AppsModal } from "./types";

interface Props {
  currentAppModal: AppsModal | undefined;
  setCurrentAppModal: (modal?: AppsModal | undefined) => void;
}

export function AppModals({
  currentAppModal,

  setCurrentAppModal,
}: Props) {
  const closeModal = () => {
    setCurrentAppModal(undefined);
  };

  return (
    <>
      <AddConnectionModal
        isOpen={currentAppModal === AppsModal.AddConnection}
        setIsOpen={closeModal}
      />
    </>
  );
}
